export default {
  outOfStock: {
    id: 'product_page_out_of_stock',
    defaultMessage: 'Out of stock',
  },
}
